export default "__VITE_PUBLIC_ASSET__b5c20cc6__"